export default __webpack_public_path__ + "static/media/saratunew.b394be0b.png";